import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTrackingContext } from '../../../context/trackingContext';
import { useUserContext } from '../../../context/userContext';
import { IoMdArrowBack } from 'react-icons/io';
import useClient from '../../../hooks/useClient';
import config from '../../../config';

const RequestData = ({ handleTabChange }) => {
  const { trackPageView, trackClick } = useTrackingContext();
  const { userData, loginHistory } = useUserContext();
  const [chatHistory, setChatHistory] = useState([]);
  const [total, setTotal] = useState(0);
  const [offset, setOffset] = useState(0);
  const client = useClient();

  useEffect(() => {
    trackPageView({
      pageName: 'Request Data page'
    });
  }, []);

  useEffect(() => {
    document.getElementById('tabContent').scrollTo(0, 0);
  }, []);

  useEffect(() => {
    fetchChatHistory(offset);
  }, []);

  const fetchChatHistory = async (offset) => {
    setOffset(offset);
    try {
      const res = await client.get(
        `${config.everywhereApi}/users/self/profile/chats?limit=50&offset=${offset}`
      );
      setTotal(res.data.data.chatData.totalChats);
      setChatHistory(res.data.data.chatData.chats);
    } catch (err) {
      console.log('err', err);
    }
  };

  return (
    <div className="mb-10 mt-8">
      <div className="w-full" id="RequestData">
        <div className="w-fit">
          <Link
            to="/account"
            onClick={() => {
              trackClick({ btnName: 'Close Request Data page' });
              handleTabChange(1);
            }}>
            <IoMdArrowBack />
          </Link>
        </div>

        <h2 className="font-Korolev-Bold text-xl uppercase mb-2 mt-6">Request Data</h2>
        <p className="mb-8">
          Please find all personal information associated to your account below.{' '}
        </p>

        <h2 className="font-Korolev-Bold text-xl mb-3">Account Details</h2>
        <hr className="w-full border-dotted border-l-0 border-b-0 border-r-0 mb-5" />
        <div className="flex flex-col gap-6 mb-10">
          <div>
            <h2>Email Addresses:</h2>
            <ul className="list-disc list-inside ">
              <li>{userData.emailAddress}</li>
              {userData.parentalEmail && <li>{userData.parentalEmail}</li>}
            </ul>
          </div>

          <div>
            <h2>First Name:</h2>
            <p>{userData.firstName}</p>
          </div>

          <div>
            <h2>Date of Birth</h2>
            <p>{userData.dob}</p>
          </div>

          <div>
            <h2>Username(s)</h2>
            <ul className="list-disc list-inside ">
              <li>{userData.username}</li>
            </ul>
          </div>
        </div>

        <div className="mb-10">
          <h2 className="font-Korolev-Bold text-xl mb-3">IP History</h2>
          <hr className="w-full border-dotted border-l-0 border-b-0 border-r-0 mb-5" />

          <table className="table-auto w-full overflow-scroll">
            <thead>
              <tr className="text-left">
                <th className="pb-1">IP Address</th>
                <th>Date and Time</th>
                <th>Country/Region</th>
              </tr>
            </thead>
            <tbody>
              {loginHistory.reverse().map((ipHistory, idx) => (
                <tr key={idx}>
                  <td className="pb-1">{ipHistory.ipAddress}</td>
                  <td>{ipHistory.dateAdded}</td>
                  <td>{ipHistory.location}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="mb-10">
          <h2 className="font-Korolev-Bold text-xl mb-3">Chat History</h2>
          <hr className="w-full border-dotted border-l-0 border-b-0 border-r-0 mb-5" />
          <p className="pb-3">
            Displaying {offset} to {offset + chatHistory.length} of {total} messages.
          </p>

          <table className="table-fixed w-full">
            <thead>
              <tr className="text-left">
                <th className="w-3/10">Date and Time</th>
                <th className="w-9/12">Message</th>
              </tr>
            </thead>
            <tbody>
              {chatHistory.map((chat, idx) => (
                <tr key={idx}>
                  <td>{chat.date}</td>
                  <td>{chat.message}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {offset > 0 && chatHistory.length > 0 && (
            <button
              className="mt-4 mr-4 uppercase w-4/12 pt-2 pb-1 bg-black text-white"
              onClick={() => fetchChatHistory(offset - 50)}>
              Previous
            </button>
          )}
          {offset + chatHistory.length < total && chatHistory.length > 0 && (
            <button
              className="mt-4 mr-4 uppercase w-4/12 pt-2 pb-1 bg-black text-white"
              onClick={() => fetchChatHistory(offset + 50)}>
              Next
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default RequestData;
